export const optionalLabelSuffix = {
  es: "Opcional",
  en: "Optional",
};

export const fileDragTip = {
  es: {
    dragOr: "Arrastrá o",
    chooseFile: "seleccioná un archivo",
    chooseFiles: "seleccioná archivos",
    fromDevice: "de tu dispositivo",
  },
  en: {
    dragOr: "Drag or",
    chooseFile: "select a file",
    chooseFiles: "select files",
    fromDevice: "from your device",
  },
};

export const tokenCard = {
  es: {
    title: "Validá tu dirección de mail",
    subtitle: "El código es válido durante 24 horas",
    primaryButton: "Guardar y Continuar",
    secondaryButton: "Volver",
    body: "Ingresá el token que enviamos a",
    resendText: "Reenviar mail",
    incorrectTokenErrorMessage: "El token es incorrecto.",
    lengthValidationErrorMessage: "Deben ser 7 caracteres.",
  },
  en: {
    title: "Validate your email address",
    subtitle: "The code is valid for 24 hours",
    primaryButton: "Save and Continue",
    secondaryButton: "Back",
    body: "Enter the token we sent to",
    resendText: "Resend email",
    incorrectTokenErrorMessage: "Incorrect token.",
    lengthValidationErrorMessage: "Has to be 7 characters long.",
  },
};

export const inputFile = {
  es: {
    sizeErrorMessage: "El archivo adjunto excede el peso máximo permitido de",
    minSizeErrorMessage: "El peso del archivo adjunto es demasiado pequeño, debe ser mayor a",
    formatErrorMessage: "Formato de archivo inválido.",
    replaceImageText: "Reemplazar imagen",
    attachImageText: "Adjuntar imagen",
  },
  en: {
    sizeErrorMessage: "File exceeds maximum file size of",
    minSizeErrorMessage: "The file size is too small, it must be greater than",
    formatErrorMessage: "Invalid file format.",
    replaceImageText: "Replace image",
    attachImageText: "Attach image",
  },
};
export const fileInfoText = (maxFileSize: number) => ({
  es: `Cargá archivos JPG, PNG, HEIC, HEIF o PDF de hasta ${maxFileSize}mb.`,
  en: `Upload a JPG, PNG, HEIC, HEIF, or PDF file up to ${maxFileSize}mb.`,
});
